import React, { useState, useEffect } from 'react'
import MobileModal from 'srcReact/components/common2/MobileModal'
import Modal from 'srcReact/components/common2/Modal'
import { TextArea } from 'srcReact/components/common2/TextArea'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import EmojisForRating from '../EmojisForRating'
import Button from 'srcReact/components/common2/Button'
import Spinner from 'srcReact/components/common2/Spinner'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

function WriteReviewModal({
  isMobileDevice,
  currentReview,
  loading,
  success,
  error,
  showSendMessageOptions = false,
  selectedRatingValue,
  isOpen,
  closeModal,
  handleRateMixr
}) {
  const { t } = useTranslation()
  const [isShareOptionModalOpen, setIsShareOptionModalOpen] = useState(false)
  const [currentRating, setCurrentRating] = useState(selectedRatingValue)
  const [postTriggered, setPostTriggered] = useState(false)
  const [review, setReview] = useState({
    name: 'review',
    value: currentReview,
    hasError: false,
    errorMessage: ''
  })

  useEffect(() => {
    if (postTriggered && !loading) {
      setPostTriggered(false)
      if (success) {
        closeModal()
        closeShareOptionModal()
      }
    }
  }, [postTriggered, loading, success, error])

  const showShareOptionModal = () => {
    setIsShareOptionModalOpen(true)
  }
  const closeShareOptionModal = () => {
    setIsShareOptionModalOpen(false)
  }

  const postReview = (isPublic) => {
    setPostTriggered(true)
    handleRateMixr(currentRating, isPublic, review.value)
  }

  const handleRatingChange = (value) => {
    setCurrentRating(value)
  }

  const renderReviewForm = () => {
    return (
      <div className={styles.formReview}>
        <TextArea
          rows={8}
          value={currentReview}
          isRequired={false}
          fieldInfo={review}
          onChange={(e) => setReview({ ...review, value: e.target.value })}
          customWrapperCss={styles.txtReview}
          maxLength={280}
          showTextLength={true}
        />
        <EmojisForRating size='large32' handleRateMixr={handleRatingChange} selectedValue={currentRating} />
        <Button
          text={t('rating.review.postReview')}
          handleClick={showSendMessageOptions ? showShareOptionModal : () => postReview(1)}
          size='large'
          customStyle={styles.btnPostReview}
        />
        {error && <ErrorMessage text={error} center={true} className={styles.error} />}
      </div>
    )
  }

  const renderShareOption = () => {
    return (
      <div className={styles.shareOptionsWrapper}>
        <div className={styles.buttons}>
          <Button style='secondary' size='large' text={t('rating.review.private')} handleClick={() => postReview(0)} />
          <Button text={t('rating.review.public')} size='large' handleClick={() => postReview(1)} />
        </div>
        {loading && <Spinner />}
        {error && <ErrorMessage text={error} center={true} className={styles.error} />}
      </div>
    )
  }

  return isMobileDevice ? (
    <MobileModal
      isOpen={isOpen}
      handleClose={isShareOptionModalOpen ? closeShareOptionModal : closeModal}
      title={
        isShareOptionModalOpen
          ? t('rating.review.title')
          : currentReview
          ? t('rating.review.editReview')
          : t('rating.review.writeReview')
      }
      subTitle={isShareOptionModalOpen ? t('rating.review.subtitle') : ''}>
      {isShareOptionModalOpen ? renderShareOption() : renderReviewForm()}
    </MobileModal>
  ) : (
    <Modal
      isOpen={isOpen}
      handleClose={isShareOptionModalOpen ? closeShareOptionModal : closeModal}
      title={
        isShareOptionModalOpen
          ? t('rating.review.title')
          : currentReview
          ? t('rating.review.editReview')
          : t('rating.review.writeReview')
      }
      subTitle={isShareOptionModalOpen ? t('rating.review.subtitle') : ''}>
      {isShareOptionModalOpen ? renderShareOption() : renderReviewForm()}
    </Modal>
  )
}

export default WriteReviewModal
